"use strict";

/**
 * @namespace gc.gis.action.editgeometry
 */
gc.gis.action.editgeometry = gc.gis.action.editgeometry || {};

/**
 * Geometrie-Bearbeiten-Modul-Events.
 * @enum {string}
 */
gc.gis.module.GCEditGeometryEvent = {
	/**
	 * Wird ausgelöst, wenn sich die Liste der verfügbaren Layer zur Bearbeitung geändert hat.
	 */
	LAYERS_UPDATED:     'update:layers',

	/**
	 * Wird ausgelöst, wenn der Nutzer den Layer zur Bearbeitung geändert hat.
	 */
	LAYER_CHANGED:      'change:layer'
};


/**
 * @classdesc
 * Geometrie-Bearbeitungs-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}] *
 * @param {Object<string,string>} options.requests
 * @param {string} [options.label='Geometrie bearbeiten']
 */
gc.gis.module.GCEditGeometry = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	this._helpTooltipSelectMsg = 'Klicken, um Objekt zu bearbeiten';
	this._helpTooltipNewVertexMsg = 'Zum <b>Einfügen</b> klicken.</br>Zum <b>Verschieben</b> klicken und ziehen.';
	this._helpTooltipEditVertexMsg = 'Zum <b>Verschieben</b> klicken und ziehen<br\>Zum <b>Löschen</b> nur klicken';

	/**
	 * @type {Object<string,*>}
	 */
	this.options       = options;
	/**
	 * @type {gc.gis.map.GCMapView}
	 */
	this.map           = options.map || gc.gis.iface.map;
	/**
	 * @type {string}
	 */
	this.label         = options.label || 'Geometrie bearbeiten';

	/**
	 * Liste der verfügbaren Layer für eine Bearbeitung
	 * @type {Object<string,gc.gis.layer.GCLayer>}
	 * @private
	 */
	this._editLayers = {};

	/**
	 * Der vom Nutzer ausgewählte Bearbeitungs-Layer.
	 * @type {gc.gis.layer.GCLayer|null}
	 * @private
	 */
	this._selectedLayer = null;

	/**
	 * Implementierung (Controller)
	 * @type {gc.gis.module.GCEditGeometry.OlImpl}
	 * @private
	 */
	this._impl = new gc.gis.module.GCEditGeometry.OlImpl({	// FIXME: ggf. über factory?
		instance:       this,
		map:            this.map
	});

	this._initContent();
	this._initEvents();
};
gc.gis.module.GCEditGeometry.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @return {jQuery}
 */
gc.gis.module.GCEditGeometry.prototype.getElement = function()
{
	return this._panel_main.getElement();
};

/**
 * Liefert eine Liste von Layern, die bearbeitet werden können.
 *
 * @return {Object<string,gc.gis.layer.GCLayer>}
 */
gc.gis.module.GCEditGeometry.prototype.getEditableLayers = function()
{
	return this._editLayers;
};

/**
 * Liefert den vom Nutzer zur Bearbeitung ausgewählten Layer.
 *
 * @return {gc.gis.layer.GCLayer}
 */
gc.gis.module.GCEditGeometry.prototype.getSelectedLayer = function()
{
	return this._selectedLayer;
};

/**
 * Speichert die übergebenen Features.
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.prototype.save = function(features)
{
	if (this._selectedLayer && features.length > 0)
	{
		var self = this;
		var service = gc.gis.iface.serviceFactory.createTransactionService(),
			service_features = this._impl.toTransactionServiceFeatures(features);

		if (service_features)
		{
			service.updateFeature(this._selectedLayer, service_features);

			service.on(gc.gis.service.FeatureServiceEvent.UPDATE_SUCCESS, this, function (evt)
			{
				var failures = 0,
					numFeatures = features.length,
					i, ii;

				for (i = 0, ii = evt.result.length; i < ii && i < numFeatures; i++)
				{
					if (true === evt.result[i].success)
					{
						self._impl.saveSuccess([features[i]]);
					}
					else
					{
						failures++;
						self._impl.saveFailed([features[i]]);
					}
				}

				if (failures === 0)
				{
					gc.gis.iface.log.info(this, 'Die Änderungen wurden gespeichert.');
				}
				else if (failures === numFeatures)
				{
					gc.gis.iface.log.error(this, 'Die Änderungen wurden nicht gespeichert.');
				}
				else
				{
					gc.gis.iface.log.warn(this, 'Es wurden ' + (numFeatures - failures) + ' von ' + numFeatures +
						' geänderte Objekte gespeichert.');
				}

				self.map.reloadMap(true, false, false); // nur Image-Layer laden, da editierbare Layer als WMS eingebunden sind
			});

			service.on(gc.gis.service.FeatureServiceEvent.UPDATE_ERROR, this, function (evt)
			{
				gc.gis.iface.log.error(this, 'Beim Speichern der Änderungen trat ein Fehler auf.');
			});
		}
	}
};

/**
 * Speichert alle geänderten Features.
 */
gc.gis.module.GCEditGeometry.prototype.saveAll = function()
{
	this.save(this._impl.getChangedFeatures());
};

/**
 * Löscht die übergebenen Features.
 *
 * @param {gc.gis.feature.GCFeature[]} features
 * @param {boolean} only_geometry
 */
gc.gis.module.GCEditGeometry.prototype.delete = function(features, only_geometry)
{
	if (this._selectedLayer && features.length > 0)
	{
		var self = this;
		var service = gc.gis.iface.serviceFactory.createTransactionService(),
			service_features = this._impl.toTransactionServiceFeatures(features, true),
			i, ii;

		if (!only_geometry)
		{
			for (i = 0, ii = service_features.length; i < ii; i++)
			{
				if (service_features[i] instanceof gc.gis.service.feature.TransactionFachDBFeature)
				{
					service_features[i].setGeometryList([]);
				}
			}
		}

		if (service_features)
		{
			service.deleteFeature(this._selectedLayer, service_features);

			service.on(gc.gis.service.FeatureServiceEvent.DELETE_SUCCESS, this, function (evt)
			{
				var failures = 0,
					numFeatures = features.length,
					i, ii;

				for (i = 0, ii = evt.result.length; i < ii && i < numFeatures; i++)
				{
					if (true === evt.result[i].success)
					{
						self._impl.deleteSuccess([features[i]]);
					}
					else
					{
						failures++;
						self._impl.deleteFailed([features[i]]);
					}
				}

				if (failures === 0)
				{
					gc.gis.iface.log.info(this, numFeatures === 1 ?
						'Das Objekt wurde gelöscht.' : 'Die Objekte wurden gelöscht.');
				}
				else if (failures === numFeatures)
				{
					gc.gis.iface.log.error(this, numFeatures === 1 ?
						'Das Objekt konnte nicht gelöscht werden.' : 'Die Objekte konnten nicht gelöscht werden.');
				}
				else
				{
					gc.gis.iface.log.warn(this, 'Es wurden ' + (numFeatures - failures) + ' von ' + numFeatures +
						' Objekten gelöscht.');
				}

				self.map.reloadMap(true, false, false); // nur Image-Layer laden, da editierbare Layer als WMS eingebunden sind
			});

			service.on(gc.gis.service.FeatureServiceEvent.DELETE_ERROR, this, function (evt)
			{
				gc.gis.iface.log.error(this, 'Beim Löschen trat ein Fehler auf.');
			});
		}
	}
};

/**
 * Aktualisiert die Nutzeroberfläche nach diversen Aktionen an den Geometrien/Objekten.
 *
 * Diese Methode wird primär durch die Aktionen aufgerufen (siehe Namespace gc.gis.action.editgeometry).
 */
gc.gis.module.GCEditGeometry.prototype.updateForm = function()
{
	this._panel_main.updateForm(this._impl.numChangedFeatures());
};

/**
 * Initialisiert die Inhaltselemente des Moduls.
 *
 * @private
 */
gc.gis.module.GCEditGeometry.prototype._initContent = function()
{
	var self = this;

	/**
	 * Haupt-Panel
	 * @type {gc.gis.module.GCEditGeometry.Panel}
	 * @private
	 */
	this._panel_main = new gc.gis.module.GCEditGeometry.Panel({
		module: self
	});

	// als Sub-Modul von Tools
	gc.gis.iface.onModuleAvailable(this, 'GCTools', function(module) {
		gc.gis.assert.isInstance(module, gc.gis.module.GCTools);

		/**
		 * Hauptbereich Sidebar-Content
		 * @type {gc.gis.ui.GCSidebarContent}
		 * @private
		 */
		self._content_main = module.addModule(self, self._panel_main.getElement(), 'ms ms-draw-polygon');
	});
};

/**
 * Initialisiert die Eventbehandlungsroutinen des Moduls.
 *
 * @private
 */
gc.gis.module.GCEditGeometry.prototype._initEvents = function()
{
	var self = this,
		i, ii;

	// Interaktion (de-)aktivieren, wenn Panel (in-)aktiv
	gc.gis.iface.ui.sidebar.on(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function(evt) {
		if(evt.newValue === self._content_main)
		{
			self._impl.setEditLayer(self._selectedLayer);
			self._impl.enableEdit(true);
			self.updateForm();
		}
		else if(evt.oldValue === self._content_main)
		{
			self._impl.enableEdit(false);
		}
	});

	// Nutzereistellungen am Panel überwachen
	this._panel_main.on(gc.gis.module.GCEditGeometryEvent.LAYER_CHANGED, this, function (evt) {
		self._selectedLayer = evt.layer;
		self._impl.setEditLayer(self._selectedLayer);

		if (self._selectedLayer &&
			self._selectedLayer.getProjection().toUpperCase() !== self.map.getProjection().toUpperCase())
		{
			gc.gis.iface.log.warn(self, 'Bitte stellen Sie die Kartenansicht zur Bearbeitung der Ebene auf '
				+ self.map.getAvailableProjectionLabel(evt.layer.getProjection()));
		}
	});

	// Karte überwachen
	this.map.on(gc.gis.map.GCMapEvent.PROJECTION_CHANGED, self, function (evt) {
		self._impl.setEditLayer(self._selectedLayer); // aktualisiert in der Impl. die Datenquelle und unterbindet ggf. das Neuladen der Daten sofern die CRS nicht übereinstimmen

		if (self._impl.isEditEnabled() && self._selectedLayer
			&& self._selectedLayer.getProjection().toUpperCase() !== evt.newValue.toUpperCase())
		{
			gc.gis.iface.log.warn(self, 'Bitte stellen Sie die Kartenansicht zur Bearbeitung der Ebene auf '
				+ self.map.getAvailableProjectionLabel(evt.newValue));
		}
	});

	// Ebenen überwachen
	// TODO Filter: nur Ebenen mit Schreibrechten berücksichtigen
	this.map.on(gc.gis.map.GCMapEvent.LAYER_ADDED, self, function (evt) {
		if(evt.layers && evt.layers.length)
		{
			for(i = 0, ii = evt.layers.length; i < ii; i++)
			{
 				if (evt.layers[i] instanceof gc.gis.layer.GCLayer
					&& evt.layers[i].getType() === gc.gis.layer.GCLayerType.FACHDB)
				{
					if (evt.layers[i].isReallyVisible())
					{
						self._addEditableLayer(evt.layers[i]);
					}

					evt.layers[i].on(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self, function(evt) {
						if (evt.newValue)
						{
							self._addEditableLayer(evt.layer);
						}
						else
						{
							self._removeEditableLayer(evt.layer);
						}
					});
				}
			}
		}
	});
	this.map.on(gc.gis.map.GCMapEvent.LAYER_REMOVED, self, function (evt) {
		if(evt.layers && evt.layers.length)
		{
			for (i = 0, ii = evt.layers.length; i < ii; i++)
			{
				if (evt.layers[i] instanceof gc.gis.layer.GCLayer
					&& evt.layers[i].getType() === gc.gis.layer.GCLayerType.FACHDB)
				{
					evt.layers[i].un(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self);
					self._removeEditableLayer(evt.layers[i]);
				}
			}
		}
	});

	// Objekt-Änderungen überwachen
	var interaction = this._impl.getTransformInteraction();
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.MODIFY_END, this, function (evt) {
		self.updateForm();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.TRANSLATING, this, function (evt) {
		self.updateForm();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.ROTATING, this, function (evt) {
		self.updateForm();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.SCALING, this, function (evt) {
		self.updateForm();
	});

	// Tooltip
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.ENTER, this, function (evt) {
		if (!evt.selected)
		{
			self.map.showMouseTooltip(self._helpTooltipSelectMsg);
		}
		else
		{
			self.map.disableMouseTooltip();
		}
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.LEAVE, this, function (evt) {
		self.map.disableMouseTooltip();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.SELECT, this, function (evt) {
		self.map.disableMouseTooltip();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.UNSELECT, this, function (evt) {
		self.updateForm();
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.HOVER_VERTEX, this, function (evt) {
		if (evt.isNew)
		{
			self.map.showMouseTooltip(self._helpTooltipNewVertexMsg);
		}
		else
		{
			self.map.showMouseTooltip(self._helpTooltipEditVertexMsg);
		}
	});
	interaction.on(gc.gis.map.GCMapTransformInteractionEvent.LEAVE_VERTEX, this, function (evt) {
		self.map.disableMouseTooltip();
	});
};

/**
 * Fügt einen Layer zur Liste der bearbeitbaren Layer hinzu.
 *
 * @method
 * @private
 * @param {gc.gis.layer.GCLayer} layer
 */
gc.gis.module.GCEditGeometry.prototype._addEditableLayer = function(layer)
{
	this._editLayers[layer.getType() + '::' + layer.getName()] = layer;
	this._fireEvent(gc.gis.module.GCEditGeometryEvent.LAYERS_UPDATED, {});
};

/**
 * Entfernt einen Layer aus der Liste der bearbeitbaren Layer.
 *
 * @method
 * @private
 * @param {gc.gis.layer.GCLayer} layer
 */
gc.gis.module.GCEditGeometry.prototype._removeEditableLayer = function(layer)
{
	var key = layer.getType() + '::' + layer.getName();
	if (this._editLayers[key])
	{
		delete this._editLayers[key];
	}
	this._fireEvent(gc.gis.module.GCEditGeometryEvent.LAYERS_UPDATED, {});
};


///////////////
//  ACTIONS  //
///////////////
/**
 * @param {gc.gis.module.GCEditGeometry} module
 * @param {gc.gis.module.GCEditGeometry.Impl} impl
 */
gc.gis.action.editgeometry.cancel = function(module, impl)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * Die Funktion wird im Context eines gc.gis.map.GCMapTransformInteraction-Objekts ausgeführt
	 * @param {gc.gis.feature.GCFeature} feature
	 */
	this.func = function(feature)
	{
		if (this.wasChanged(feature))
		{
			gc.gis.iface.ui.showDialog({
				type: gc.gis.widget.GCDialogType.CONFIRM,
				title: 'Änderung Speichern',
				content: 'Die Geometrie des Objekts wurde verändert. Soll diese Veränderung gespeichert werden?',
				submit: function(dlg)
				{
					module.save([feature]);
					dlg.dispose();
				},
				cancel: function (dlg)
				{
					impl.editCancel([feature]);
				}
			});
		}
		else
		{
			this.unSelectFeature(feature);
		}
	};
};
gc.gis.action.editgeometry.cancel.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * @param {gc.gis.module.GCEditGeometry} module
 */
gc.gis.action.editgeometry.save = function(module)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * Die Funktion wird im Context eines gc.gis.map.GCMapTransformInteraction-Objekts ausgeführt
	 * @param {gc.gis.feature.GCFeature} feature
	 */
	this.func = function(feature)
	{
		if (this.wasChanged(feature))
		{
			module.save([feature]);
		}
	};
};
gc.gis.action.editgeometry.save.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * @param {gc.gis.module.GCEditGeometry} module
 */
gc.gis.action.editgeometry.delete = function(module)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * Die Funktion wird im Context eines gc.gis.map.GCMapTransformInteraction-Objekts ausgeführt
	 * @param {gc.gis.feature.GCFeature} feature
	 */
	this.func = function(feature)
	{
		var self = this;
		gc.gis.iface.ui.showDialog({
			type: gc.gis.widget.GCDialogType.CUSTOM,
			title: 'Geometrie/Fachobjekt Löschen',
			content: 'Soll das ausgewählte Koordinatenobjekt oder das zugehörige gesamte Fachobjekt wirklich gelöscht werden?',
			buttons: [
				{
					label: 'nur Koordinatenobjekt',
					type: gc.gis.widget.GCDialogButtonType.DANGER,
					key: 'delete_geom'
				},
				{
					label: 'gesamtes Fachobjekt',
					type: gc.gis.widget.GCDialogButtonType.DANGER,
					key: 'delete'
				},
				{
					label: 'Abbrechen',
					type: gc.gis.widget.GCDialogButtonType.DEFAULT,
					key: 'cancel'
				}
			],
			custom: function(dlg, btn)
			{
				if (btn.key.substr(0, 6) === 'delete')
				{
					module.delete([feature], 'delete_geom' === btn.key);
				}
				dlg.dispose();
			}
		});
	};
};
gc.gis.action.editgeometry.delete.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * @param {gc.gis.module.GCEditGeometry} module
 * @param {gc.gis.module.GCEditGeometry.Impl} impl
 */
gc.gis.action.editgeometry.clearDrawArea = function(module, impl)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * Die Funktion wird im Context eines gc.gis.layer.GCTrackingLayer-Objekts ausgeführt und in
	 * gc.gis.control.GCDrawingAreaClear._doClear() aufgerufen
	 */
	this.func = function()
	{
		var numChanged = impl.numChangedFeatures();
		if (numChanged > 0)
		{
			var self = this;
			gc.gis.iface.ui.showDialog({
				type: gc.gis.widget.GCDialogType.CONFIRM,
				title: 'Änderung' + (numChanged > 1 ? 'en' : '') + ' Speichern',
				content: numChanged > 1 ?
					numChanged + ' Geometrien wurden geändert. Sollen diese Änderung gespeichert werden?' :
					'Eine Geometrie wurde geändert. Soll diese Änderung gespeichert werden?',
				submit: function(dlg)
				{
					module.save(impl.getChangedFeatures());
					dlg.dispose();
					self.clear();
				},
				cancel: function (dlg)
				{
					impl.editCancel(impl.getChangedFeatures());
					self.clear();
				}
			});
		}
		else
		{
			this.clear();
		}
	};
};
gc.gis.action.editgeometry.clearDrawArea.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);
